'use client';

import { useTenant } from '../../../../../providers/tenant/TenantProvider';
import { fireConversion } from './fireConversion';
import type { GoogleAdsTrackingConfig, MetaTrackingConfig } from './types';

interface Args {
  formId?: string;
  metaTracking?: MetaTrackingConfig;
  googleAdsTracking?: GoogleAdsTrackingConfig;
}

/** Binds the form's tracking config and the tenant's Google Ads ID. */
export const useFireConversion = ({
  formId,
  metaTracking,
  googleAdsTracking,
}: Args) => {
  const { tenantConfig } = useTenant();
  const googleAdsId = tenantConfig.integration?.googleAdsId;

  return (values: Record<string, string>) =>
    fireConversion({
      formId,
      values,
      metaTracking,
      googleAdsTracking,
      googleAdsId,
    });
};
